import axios from 'axios';
import { X_API_KEY } from '../utils/authentication';

const apiVersion = "v1"
// from the root of the site
let apiUrl = `${window.location.origin}/ledmodulestore/api/${apiVersion}`;

const ledmodulesAction = 'modules';

function getApiBaseUrl() {
    return apiUrl;
}

export function getLedModulesApiUrl() {
    return '';
}

const instance = axios.create({
    baseURL: `${getApiBaseUrl()}/${ledmodulesAction}`,
    timeout: 30000,
    headers: { 'Access-Control-Allow-Origin': '*', 'CLIENT-ID': "Frontend" }
});

instance.interceptors.request.use(config => {
    if (localStorage.getItem(X_API_KEY) !== null && typeof localStorage.getItem(X_API_KEY) === 'string' && localStorage.getItem(X_API_KEY) !== '') {
        config.headers['X-API-KEY'] = localStorage.getItem(X_API_KEY);
    } else {
        delete config.headers['X-API-KEY'];
    }
    return config;
});

export default instance;
